export default "__VITE_ASSET__6d2895ec__"